import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  itemName: string;
  categoryName: string;
};

const CategoryChangeErrorToast = ({ categoryName, itemName }: Props) => {
  return (
    <FormattedMessage
      id="menu.itemMoveToCategoryFail"
      values={{
        item: itemName,
        category: categoryName,
        bold: chunks => <b>{chunks}</b>,
      }}
    />
  );
};

export default CategoryChangeErrorToast;
